import React from 'react';
import { Reveal } from './motion';

// `title` accent word goes in {{ }}.
const SectionHead = ({ index, label, title, children, className = '' }) => (
  <Reveal className={`mb-6 max-w-3xl ${className}`}>
    <p className="font-mono-label text-[var(--muted)] flex items-center gap-3 mb-6"><span className="text-[var(--red)]">{index}</span><span className="w-10 h-px bg-[var(--line-strong)]" />{label}</p>
    <h2 className="font-display text-5xl sm:text-6xl leading-[1]">
      {title.split(/(\{\{.*?\}\})/).map((p, i) => p.startsWith('{{') ? <em key={i} className="text-[var(--red)]">{p.slice(2, -2)}</em> : p)}
    </h2>
    {children && <p className="mt-6 text-lg text-[var(--muted)] leading-relaxed">{children}</p>}
  </Reveal>
);

export default SectionHead;
